import {Component, ViewEncapsulation, HostListener} from '@angular/core';
import {ConstructionToolsComponent} from '../widgets/construction-tools/construction-tools.component';
import {WidgetWindow, WindowWidgetsService} from './window-widgets.service';
import {AlertModalService} from '../../common/component/modal';
import {AngleUtilService} from '../services/features/angle/angle-util.service';
import {AnnotationService} from '../services/features/annotation.service';
import {ConstructionToolServiceFactory} from '../widgets/construction-tools/construction-tool/construction-tool-service.factory';
import {ConstructionToolModelService} from '../widgets/construction-tools/construction-tool/services/construction-tool-model.service';
import {FeatureApplyDeleteService} from '../services/feature-apply-delete.service';
import {LineService} from '../services/features/line.service';
import {LookupService} from '../../common/service/lookup.service';
import {MergeLinesConstructionToolService} from '../widgets/construction-tools/construction-tool/services/merge-lines-construction-tool.service';
import {MapModeService} from '../services/map-mode.service';
import {MapService} from '../services/map.service';
import {MapToolsService} from '../services/map-tools.service';
import {PermissionsService} from '../../common/service/permissions.service';
import {PolygonUtilService} from '../services/features/polygon-util.service';
import {SpatialUtilService} from '../services/spatial-util.service';
import {SpatialSnapshotService} from '../snapshot/spatial-snapshot.service';
import {TraitsService} from '../../common/service/traits.service';
import {UserPreferencesService} from '../../common/service/user-preferences.service';
import {WidgetService} from '../services/widget.service';
import {SpatialSequenceService} from '../../common/service/spatial-sequence.service';
import {LotConstructionToolService} from '../widgets/construction-tools/construction-tool/services/lot-construction-tool.service';
import {MapEventsService} from '../services/map-events.service';
import {GraphicSelectionService} from '../services/graphic-selection.service';
import {PlanModelService} from '../../common/service/plan-model.service';
import {AppConfigService} from '../../common/service/app-config.service';
import {AuthenticatorService} from '../../common/service/authenticator.service';
import {EsriModuleService} from '../esri-nlr/services/esri-module.service';
import {MergePointsConstructionToolService} from '../widgets/construction-tools/construction-tool/services/merge-points-construction-tool.service';
import {NgEventBus} from 'ng-event-bus';
import {ArcGisAuthService} from '../services/arc-gis-auth.service';

const getProviders = () => {
    const windowContext = (window as WidgetWindow).nlrpContext;

    if (!windowContext) {
        return [];
    }
    return [
        {
            provide: ArcGisAuthService,
            useValue: windowContext.arcGisAuthService
        },
        {
            provide: AppConfigService,
            useValue: windowContext.appConfigService
        },
        {
            provide: AuthenticatorService,
            useValue: windowContext.authenticatorService
        },
        {
            provide: AlertModalService,
            useValue: windowContext.alertModalService
        },
        {
            provide: AngleUtilService,
            useValue: windowContext.angleUtilService
        },
        {
            provide: AnnotationService,
            useValue: windowContext.annotationService
        },
        {
            provide: ConstructionToolServiceFactory,
            useValue: windowContext.constructionToolServiceFactory
        },
        {
            provide: ConstructionToolModelService,
            useValue: windowContext.constructionToolModelService
        },
        {
            provide: EsriModuleService,
            useValue: windowContext.esriModuleService
        },
        {
            provide: FeatureApplyDeleteService,
            useValue: windowContext.featureApplyDeleteService
        },
        {
            provide: GraphicSelectionService,
            useValue: windowContext.graphicSelectionService
        },
        {
            provide: LineService,
            useValue: windowContext.lineService
        },
        {
            provide: LookupService,
            useValue: windowContext.lookupService
        },
        {
            provide: LotConstructionToolService,
            useValue: windowContext.lotConstructionToolService
        },
        {
            provide: MergeLinesConstructionToolService,
            useValue: windowContext.mergeLinesConstructionToolService
        },
        {
            provide: MergePointsConstructionToolService,
            useValue: windowContext.mergePointsConstructionToolService
        },
        {
            provide: MapEventsService,
            useValue: windowContext.mapEventsService
        },
        {
            provide: MapModeService,
            useValue: windowContext.mapModeService
        },
        {
            provide: MapService,
            useValue: windowContext.mapService
        },
        {
            provide: MapToolsService,
            useValue: windowContext.mapToolsService
        },
        {
            provide: NgEventBus,
            useValue: windowContext.eventBus
        },
        {
            provide: PermissionsService,
            useValue: windowContext.permissionsService
        },
        {
            provide: PlanModelService,
            useValue: windowContext.planModelService
        },
        {
            provide: PolygonUtilService,
            useValue: windowContext.polygonUtilService
        },
        {
            provide: SpatialSequenceService,
            useValue: windowContext.spatialSequenceService
        },
        {
            provide: SpatialUtilService,
            useValue: windowContext.spatialUtilService
        },
        {
            provide: SpatialSnapshotService,
            useValue: windowContext.spatialSnapshotService
        },
        {
            provide: TraitsService,
            useValue: windowContext.traitsService
        },
        {
            provide: UserPreferencesService,
            useValue: windowContext.userPreferencesService
        },
        {
            provide: WidgetService,
            useValue: windowContext.widgetService
        },
        {
            provide: WindowWidgetsService,
            useValue: windowContext.windowWidgetsService
        }
    ];
};

@Component({
    selector: 'nlr-window-widgets',
    templateUrl: './window-widgets.component.html',
    styleUrls: ['../design.component.scss', './window-widgets.component.scss'],
    imports: [ConstructionToolsComponent],
    encapsulation: ViewEncapsulation.None,
    providers: getProviders()
})
export class WindowWidgetsComponent {
    constructor(private windowWidgetsService: WindowWidgetsService) {}

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.altKey && event.key === 'c') {
            this.windowWidgetsService.closeAll();
        }
    }
}
